export interface AnalyticPayloadV3 {
  organisation: string;
  type: string;
  page_id: string;
  referrer: string;
  url: string;
  device: string;
  video_id?: string;
  session_id: string;
  design_variant: string;
  integration_type: string;
}

const postRequest = <T>(endpoint: string) => (payload: T) => {
  navigator.sendBeacon(endpoint, new Blob([JSON.stringify(payload)]));
};

export const sendBeaconV3 = postRequest<AnalyticPayloadV3>(__ANALYTICS_ENDPOINT_V3__);

export const metrics = (pageId: string, pageUrl: string, componentSessionId: string, campaignName: string, isSafeFrame: boolean) => {
  const designVariant = __CONFIG__.designVariant;
  const baseComponentMetric = {
    integration_type: __CONFIG__.integrationType,
    design_variant: designVariant,
    session_id: componentSessionId,
    page_id: pageId,
    organisation: __CONFIG__.organisation,
    referrer: window.document.referrer || null,
    url: pageUrl,
    device: /Mobi/i.test(window.navigator.userAgent) ? 'mobile' : 'desktop',
    video_id: null,
    campaign_name: campaignName,
    safe_frame: isSafeFrame
  };

  return (extra: { "type": string, [k: string]: any }) => sendBeaconV3({
    ...baseComponentMetric,
    design_variant: extra.custom_6,
    ...extra
  });
}